export default __webpack_public_path__ + "static/media/roboto-v20-latin-regular.176f8f5b.woff2";